import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import styles from './NotificationBtn.module.scss'
import { ComponentProps, Dispatch, RefObject, SetStateAction } from 'react';

interface NotificationBtnProps extends ComponentProps<"div"> {
  modalIsOpen: boolean
  setModalIsOpen: Dispatch<SetStateAction<boolean>>
  anchorRef: RefObject<SVGSVGElement>
}

const NotificationBtn = (props: NotificationBtnProps) => {
  const {modalIsOpen, setModalIsOpen, anchorRef} = props;
  return (
    <CircleNotificationsIcon
      ref={anchorRef} 
      className={styles.icon}
      onClick={() => {setModalIsOpen(cur => !cur)}}
      style={{color: modalIsOpen ? 'white' : 'var(--primary-color)'}}
    />
  )
}

export default NotificationBtn